// extracted by mini-css-extract-plugin
module.exports = {"searchResultsDropdownContainer":"SearchBox_searchResultsDropdownContainer__t7uro","headerIcon":"SearchBox_headerIcon__cztfs"};